import * as actionTypes from 'constants/ActionTypes';

export function getStatisticsEmails(from, until, isWorkingHours) {
    return {
        type: actionTypes.GET_STATISTICS_EMAILS.REQUEST,
        from,
        until,
        isWorkingHours,
    };
}

export function searchStatisticsEmails(searchText) {
    return {
        type: actionTypes.SEARCH_STATISTICS_EMAILS,
        searchText,
    };
}



// WEBPACK FOOTER //
// ./app/actions/statistics/emails.js